<agr-form-dialog
  [formGroup]="formGroup"
  [data]="data"
  [disableSubmitButtonOnFormInvalid]="true"
  [titleBadge]="modeBadge$ | async"
  [titleBadgeBackgroundColor]="modeBadgeBgColor$ | async"
  (alt)="alt()"
  (cancel)="cancel()"
  (confirm)="confirmEditCropFields($event)"
  data-test="quickEdit-cropfields"
>
  <div class="flex--column flex--nowrap" style="height: 100%">
    <mat-toolbar
      [color]="isSearching === true ? 'primary' : null"
      [class.mat-toolbar-transparent]="isSearching === false"
    >
      <mat-toolbar-row>
        <div class="flex--row">
          <mat-checkbox
            (change)="$event ? masterToggle() : null"
            [checked]="areAllSelected()"
            [indeterminate]="areSomeSelected()"
            color="primary"
            class="spacing--margin-right"
            data-test="quick-edit-toolbar-masterToggle"
          >
          </mat-checkbox>
          @if (areAnySelected()) {
            <div>
              {{ getSelectedCount() }} {{ 'selectedItems' | translate }}
              @if (getSelectedCount() < relevantCropFields.length) {
                <button
                  mat-flat-button
                  color="accent"
                  (click)="selectAll()"
                  class="flex__child--none"
                >
                  {{ 'selectAll' | translate }}
                </button>
              }
              @if (getSelectedCount() === relevantCropFields.length) {
                <button
                  mat-flat-button
                  color="accent"
                  (click)="clearAll()"
                  class="flex__child--none"
                >
                  {{ 'deselectAll' | translate }}
                </button>
              }
            </div>
          }
        </div>
        @if (!areAnySelected()) {
          <mat-form-field
            class="text--body full-width-field flex__child--auto"
            data-test="quick-edit-search"
            appearance="fill"
          >
            <input
              #search
              type="text"
              [placeholder]="'search' | translate"
              [formControl]="searchControl"
              matInput
              data-test="quick-edit-search-input"
            />
          </mat-form-field>
        }
        @if (!areAnySelected() && isSearching) {
          <button
            mat-icon-button
            (click)="closeSearch()"
            class="flex__child--none"
            data-test="quick-edit-closeSearch"
          >
            <mat-icon>clear</mat-icon>
          </button>
        }
        @if (areAnySelected()) {
          <button
            mat-button
            (click)="deleteSelectedCropFields()"
            class="flex__child--none"
            data-test="quick-edit-delete"
          >
            <mat-icon>delete</mat-icon>
            {{ 'delete' | translate }}
          </button>
        }
      </mat-toolbar-row>
    </mat-toolbar>

    <div class="flex__child--auto" #container style="min-width: fit-content">
      <agr-notification-empty
        [isEmpty]="relevantCropFields?.length === 0"
        [emptyTitle]="(isSearching ? 'noCropFieldsSearchTitle' : 'noCropFieldsTitle') | translate"
        [emptyDescription]="
          (isSearching ? 'noCropFieldsSearchDescription' : 'noCropFieldsDescription') | translate
        "
        emptyActionIcon="clear"
        [emptyActionText]="'resetCropFieldSearch' | translate"
        [showEmptyAction]="isSearching"
        [emptyImage]="false"
        (emptyAction)="closeSearch()"
        class="cropfield-grid"
        style="overflow: visible"
      >
        @if (!renderQuickEditFormComponents) {
          <mat-spinner class="prerender-spinner" [diameter]="75"></mat-spinner>
        }

        @if (renderQuickEditFormComponents) {
          <mat-list data-test="registration-cropfield-list" style="padding-bottom: 8px">
            @for (cropField of dataSource; track trackByCropField(i, cropField); let i = $index) {
              <mat-list-item class="cropfield-row" data-test="quick-edit--cropfield-item">
                <div [ngClass]="{ 'border-top--gray4': i !== 0 }" class="cropfield-row__wrapper">
                  <mat-checkbox
                    (click)="$event.stopPropagation()"
                    (change)="$event ? selection.toggle(cropField.id) : null"
                    [checked]="selection.isSelected(cropField.id)"
                    color="primary"
                    class="spacing--margin-right cropfield-row__checkbox"
                    data-test="quick-edit-toggle"
                  >
                  </mat-checkbox>
                  <app-cropfield-detail
                    [formGroup]="formGroupByCropFieldId[cropField.id]"
                    [data]="data"
                    [cropField]="cropField"
                    [bemCropVarieties]="bemCropVarietiesByCropId[cropField.cropId]"
                  ></app-cropfield-detail>
                </div>
              </mat-list-item>
            }
          </mat-list>
        }
        <mat-paginator
          #paginator
          (page)="handlePageEvent($event, container)"
          [length]="relevantCropFields.length"
          [pageSize]="pageSize"
          [pageSizeOptions]="[5, 10, 25, 100]"
        >
        </mat-paginator>
      </agr-notification-empty>
    </div>
  </div>
</agr-form-dialog>
